import { AuthState, User } from "./types";

type AuthAction =
  | {
      type: 'INITIALISED' | 'USER_UPDATED' | 'LOGIN';
      user?: User;
    }
  | { type: 'LOGOUT' }
  | { type: 'ERROR'; error: Error }
  | { type: 'UPDATE_NAVIGATION_STATE'; canNavigateState: boolean };

/**
 * Handles how that state changes in the `useAuth` hook.
 */
export const reducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'INITIALISED':
      return {
        ...state,
        isAuthenticated: !!action.user,
        canNavigateState: true,
        user: action.user,
        isLoading: false,
        error: undefined,
      };
    case 'USER_UPDATED':
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated: !!action.user,
        canNavigateState: true,
        user: action.user,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        user: undefined,
      };
    case 'ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case 'UPDATE_NAVIGATION_STATE':
      return {
        ...state,
        canNavigateState: action.canNavigateState,
      };
  }
};
